import React from 'react';
import { useDataContext } from "../../context/datacontext";
import { Container } from 'react-bootstrap';
import Player from './player';

const positions = ["p1", "p2", "p3", "p4", "p5", "p6", "p7", "p8", "p9", "p10", "p11","p12","p13","p14","p15","b1","b2","b3","b4","b5","b6","b7"];

const Lineup = () => {
    const { lineup } = useDataContext();

    return (    <div className='squad-container'>
        <Container>
            {positions.map((position, index) => {
                const playerid = lineup[position];

                return <Player key={position} pos={index+1} id={playerid ? playerid.toString() : ""} />
            })}
        </Container>
    </div>);
}

export default Lineup;